<template>
    <div class="base-flex">
        <div class="left-side">
            <left-side></left-side>
        </div>
        <div class="main">
            <data-flow-component></data-flow-component>
        </div>
    </div>
</template>

<script>
import DataFlowComponent from "@/components/DataFlow/index"
import LeftSide from "./components/LeftSide"
import {getConnection} from "@/api/database/database"
export default {
    name:"DataFlow",
    components:{
        DataFlowComponent,LeftSide
    },
    mounted(){
        getConnection().then(connections=>{
            this.$store.commit("putConnections",connections)
            
        })
    }
}
</script>
<style scoped>
.left-side{
    width:200px;
    height:calc(100vh - 80px);
}
.main{
    flex:1;
    overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/DataFlowPage/index.vue